/**
 * Shared region resolver for Package records.
 *
 * Region data lives primarily in the `geo_locations` array. The legacy
 * `geo_location` string is a fallback for records whose array is empty.
 * Values are returned as-is (no lowercasing / snake-casing) so the filter
 * dropdown, filter logic, and the table column all use one canonical set
 * of strings and can match exactly.
 */
export function getPackageRegions(pkg) {
  if (Array.isArray(pkg?.geo_locations) && pkg.geo_locations.length > 0) {
    return pkg.geo_locations
      .map((r) => (typeof r === "string" ? r.trim() : r))
      .filter((r) => typeof r === "string" && r.length > 0);
  }
  const legacy = pkg?.geo_location;
  if (typeof legacy === "string" && legacy.trim()) return [legacy.trim()];
  return [];
}

/**
 * Build the sorted, de-duplicated union of region strings across a list of
 * packages. Used to populate the region filter dropdown.
 */
export function buildRegionOptions(packages) {
  const set = new Set();
  for (const p of packages) {
    for (const r of getPackageRegions(p)) set.add(r);
  }
  return Array.from(set).sort((a, b) => a.localeCompare(b));
}